import React, {useEffect, useState} from "react";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4, VsiH6, VsiSpanText} from "../../../styled/App.styled";
import VsiLabeledSelect from "../../../components/VsiLabeledSelect";
import XRangeChart from "../../../components/XRangeChart";
import {useSearchParams} from "react-router-dom";
import {Row, Col, Card,} from 'reactstrap';
import {lightOrDark} from "../../../utils/Helpers";
import themeStyles from "../../../utils/themeStyles";

const groupTypes = [
    {
        label: 'Data Center',
        value: 'data_center',
    },
    {
        label: 'Device Type',
        value: 'device_type_description',
    }
];
const grtSixMo = '#0066b5';
const lstSixMo = 'orange';
// const lstThreeMo = 'orange';
const atSuppEnd = 'red';

const legendH = 10;
const legendW = 25;
const border = '1px solid lightgray';
export default function EndOfSupportCalendar({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client } = useVsiAppContext();

    const [searchParams, setSearchParams] = useSearchParams();
    const [{recordset: supportData}, {isLoading}] = useDataWithRoute(`/api/v6/report/business_unit_support_lifecycle?client_id=${client.clientId}`);

    // const [buOptions] = useState(groupTypes);
    const [buOption, setBuOption] = useState(groupTypes.find(group => group.value === searchParams.get('group_type')) || groupTypes[0]);
    const [allGroups, setAllGroups] = useState([]);
    const [allDataObj, setAllDataObj] = useState({});

    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);

    useEffect(() => {
        const groupsArr = [];
        const groupsObj = {};
        const today = Date.now();
        let min, max = null;
        let color = grtSixMo;

        supportData.forEach(datum => {
            const bu = datum[buOption.value];
            if (!groupsObj[bu]) {
                groupsObj[bu] = {};
            }
            if (!groupsArr.includes(bu)) {
                groupsArr.push(bu);
            }

            const x = new Date(datum.purchase_date).getTime() < 0 ? Date.now() : new Date(datum.purchase_date).getTime();
            const x2 = new Date(datum.end_of_maintenance_date).getTime();

            if (min === null || x < min) {
                min = x;
            }
            if (max === null || x2 > max) {
                max = x2;
            }

            if (x2 - today < 0) {
                color = atSuppEnd;
            } else if (x2 - today <= 15778800000) {
                color = lstSixMo;
            }

            groupsObj[bu][datum.device_name] = {
                x,
                x2,
                color,
            }
        });

        setAllDataObj(groupsObj);
        setAllGroups(groupsArr);
        setMin(min);
        setMax(max);

    }, [supportData, buOption]);

    const onTypeChange = type => {
        searchParams.set('group_type', type.value);
        setSearchParams(searchParams);
        setBuOption(type);
    }

    const minDate = new Date(min);
    const maxDate = new Date(max);

    const minDateYear = minDate.getFullYear();
    const maxDateYear = maxDate.getFullYear();

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>End of Support Calendar</VsiH4>
        <VsiBubble noAutobot>
        <VsiLabeledSelect isDisabled={isLoading}
                          isLoading={isLoading}
                          label={"Group Type:"}
                          options={groupTypes}
                          onChange={onTypeChange}
                          defaultValue={buOption}/>
        </VsiBubble>
        <VsiBubble noAutobot>
            <Row>
                {/*<Col xs={12} className={'d-flex flex-row justify-content-center'}>*/}
                {/* <span className={"text-right"}>Time until end of support</span>*/}
                {/*</Col>*/}
                <Col xs={12}>
                    <div className={'d-flex flex-row justify-content-start'}>
                        <div className={"d-flex flex-row justify-content-center align-items-center ps-1"} style={{
                            borderBottom: '1px solid lightgray'
                        }}>
                            <div style={{
                                height: legendH,
                                width: legendW,
                                background: grtSixMo,
                                border,
                            }}/>
                            <VsiSpanText className={'ps-1'}>{'> 6 months'}</VsiSpanText>
                        </div>
                        <div className={"d-flex flex-row justify-content-center align-items-center ps-1"} style={{
                            borderBottom: '1px solid lightgray'
                        }}>
                            <div style={{
                                height: legendH,
                                width: legendW,
                                background: lstSixMo,
                                border,
                            }}/>
                            <VsiSpanText className={'ps-1'}>{'< 6 months'}</VsiSpanText>
                        </div>
                        <div className={"d-flex flex-row justify-content-center align-items-center ps-1"} style={{
                            borderBottom: '1px solid lightgray'
                        }}>
                            <div style={{
                                height: legendH,
                                width: legendW,
                                background: atSuppEnd,
                                border,
                            }}/>
                            <VsiSpanText className={'ps-1'}>{'At Support End'}</VsiSpanText>
                        </div>
                    </div>
                </Col>
            </Row>
        </VsiBubble>
        <VsiBubble autobotName='XRangeChart' unit={buOption.value} autobotInfo={{ data: allDataObj }}>
            <Row>
                {allGroups.map((center, centerIndex) => {
                    const chartCategories = Object.keys(allDataObj[center]);
                    const chartData = chartCategories.map((cat, catI) => {
                        return {
                            ...allDataObj[center][cat],
                            y: catI,
                        }
                    });

                    // const bgColor = highChartsPieColorsGeneric?.[centerIndex] || highChartsPieColorsGeneric[centerIndex - allDataCenters.length - 2];
                    const bgColor = centerIndex === 0 || centerIndex % 2 === 0 ? themeStyles[theme].altBgColor : themeStyles[theme].cardBgColor;

                    return <Col xs={12} key={`${center}_support_area_dc_${centerIndex}`} className={'m-1'} style={{
                        background: bgColor,
                        border: "8px dashed " + bgColor,
                        borderRadius: '5px'
                    }}>
                        <Row>
                            <Col xs={1} className={'d-flex flex-column justify-content-center align-items-center'}>
                                {/*<i style={{*/}
                                {/*  color: lightOrDark(bgColor) === 'light' ? 'black' : 'white',*/}
                                {/*}} className="fas fa-database type_icon" id={"dc_tip_" + centerIndex}/>*/}
                                <VsiH6 style={{
                                    color: lightOrDark(bgColor) === 'light' ? 'black' : 'white',
                                }}>{center}</VsiH6>
                            </Col>
                            <Col xs={11}>
                                <XRangeChart data={chartData}
                                             titleName={center}
                                             min={Date.UTC(minDateYear, 1, 1)}
                                             max={Date.UTC(maxDateYear, 12, 31)}
                                             backgroundColor={'rgb(255,255,255, .9)'}
                                             categories={chartCategories}
                                             height={100 * chartData.length}/>
                            </Col>
                        </Row>
                    </Col>
                })}

            </Row>
        </VsiBubble>
    </Card>
}
